import React from 'react';
import { IClientInfo } from '../../lib/types';
import { TopBar } from './TopBar';
import { Sidebar } from './Sidebar';
import styles from '../../styles/AuthenticatedHome.module.css';

interface HomeLayoutProps {
  children: React.ReactNode;
  themeConfig: IClientInfo;
  translations: any;
  showTopBar?: boolean;
  hideSchedule?: boolean;
}

/**
 * Shared layout for all authenticated home pages
 * Includes TopBar, Sidebar, and theme configuration
 */
export const HomeLayout: React.FC<HomeLayoutProps> = ({
  children,
  themeConfig,
  translations,
  showTopBar = true,
  hideSchedule = false,
}) => {
  const cssVariables = {
    '--brand-color': themeConfig.colors.brand,
    '--background-color': themeConfig.colors.background,
    '--surface-color': themeConfig.colors.surface,
    '--placeholder-color': themeConfig.colors.placeholder,
  } as React.CSSProperties;

  return (
    <div className={styles.container} style={cssVariables}>
      {showTopBar && <TopBar translations={translations} />}
      <div className={styles.bodyContainer}>
        <Sidebar translations={translations} hideSchedule={hideSchedule} />
        <main className={styles.mainContent}>
          {children}
        </main>
      </div>
    </div>
  );
};
